import { render, staticRenderFns } from "./fullSwiper.vue?vue&type=template&id=04186712&scoped=true&"
import script from "./fullSwiper.vue?vue&type=script&lang=js&"
export * from "./fullSwiper.vue?vue&type=script&lang=js&"
import style0 from "./fullSwiper.vue?vue&type=style&index=0&id=04186712&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04186712",
  null
  
)

export default component.exports